module.exports = __webpack_public_path__ + "img/autio-line2.f82a4252.svg";